export function stringifyParams(data) {
  let params = {};

  for (let param in data) {
    params[param] = stringify(data[param]);
  }

  return params;
}

export function stringify(data, param = "id") {
  if (Array.isArray(data)) {
    return data.map((el) => (param ? el[param] : el)).join(",");
  }

  if (typeof data == "boolean" || typeof data == "number") {
    return data.toString();
  }

  return data[param].toString();
}
